import * as Icons from 'lucide-react';
import { Heart } from 'lucide-react';
import { ministries } from '../mock';
import { Card, CardContent } from '../components/ui/card';

export const Ministries = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="relative h-[400px] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-blue-500 to-blue-800" />
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-7xl md:text-8xl font-bold text-white mb-4">Our Ministries</h1>
          <p className="text-2xl text-yellow-300">Serving God and Our Community Together</p>
        </div>
      </section>

      {/* Ministries Grid */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <p className="text-xl text-blue-700 max-w-3xl mx-auto">
              Our ministries are the heart of our church, bringing together members to serve, 
              worship, and grow in faith. Join us in making a difference in lives through service and fellowship.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {ministries.map((ministry) => {
              const IconComponent = Icons[ministry.icon];
              return (
                <Card
                  key={ministry.id}
                  className="border-2 border-yellow-400 hover:border-yellow-500 transition-all duration-200 hover:shadow-2xl transform hover:-translate-y-1"
                >
                  <CardContent className="p-8">
                    <div className="bg-gradient-to-br from-blue-500 to-blue-600 w-16 h-16 rounded-xl flex items-center justify-center mb-6 shadow-lg">
                      <IconComponent className="h-8 w-8 text-white" />
                    </div>
                    <h3 className="text-3xl font-bold text-blue-800 mb-4">{ministry.name}</h3>
                    <p className="text-blue-700 leading-relaxed">{ministry.description}</p>
                  </CardContent>
                </Card>
              );
            })}
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-16 bg-gradient-to-br from-yellow-50 to-blue-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-5xl md:text-6xl font-bold text-blue-800 mb-4">Get Involved</h2>
          <p className="text-xl text-blue-700 mb-8">
            Interested in joining one of our ministries? We&apos;d love to have you serve alongside us. Come visit us on Sunday to learn more!
          </p>
        </div>
      </section>

      {/* Donation Section with QR Code */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <Card className="border-4 border-yellow-400 shadow-2xl bg-gradient-to-br from-blue-50 to-white">
            <CardContent className="p-12 text-center">
              <div className="bg-yellow-400 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6">
                <Heart className="h-10 w-10 text-blue-800" />
              </div>
              <h2 className="text-5xl md:text-6xl font-bold text-blue-800 mb-6">Donate Today!</h2>
              <p className="text-2xl text-blue-700 mb-6">
                Support our ministry and help us continue spreading God&apos;s love in our community
              </p>
              <div className="bg-white p-6 rounded-xl border-2 border-blue-300 inline-block">
                <p className="text-xl text-blue-800 mb-3 font-semibold">Send Zelle to: truelovembc</p>
                <img src="/images/zelle-qr.png" alt="Zelle QR Code for truelovembc" className="mx-auto max-w-[250px] rounded-lg" />
              </div>
            </CardContent>
          </Card>
        </div>
      </section>
    </div>
  );
};
